import React, { useState, useEffect } from "react";
import { Popover } from './Popover/Popover';
export function ContextMenu({ children, target = document.documentElement, hideOnClick = true }) {
    const [position, setPosition] = useState();
    useEffect(() => {
        const rightClick = (e) => { e.preventDefault(); setPosition({ x: e.clientX, y: e.clientY }); };
        target?.addEventListener('contextmenu', rightClick);
        return () => target?.removeEventListener('contextmenu', rightClick);
    }, [target]);
    return React.createElement(Popover, { position: position, hideOnClick: hideOnClick }, children);
}
